import { FLIGHT_CATEGORY } from "./aircraftConstants"
import { ATTACK_SETTING_NAMES, GAME_ATTACK_TYPES } from "./gameAttackConstants"

export const ATTCACK_TIME_CONSTANTS = {
    ZERO: 0,
    ONE_MINUTE: 60,
    TWO_MINUTES: 120,
    THREE_MINUTES: 180,
    FOUR_MINUTES: 240,
    FIVE_MINUTES: 300,
    EIGHT_MINUTES: 480,
};

export const ATTACK_SCORE_MAP = {
    HUNDRED_POINTS: {
        TIME_INTERVAL: {
            MIN: 0,
            MAX: ATTCACK_TIME_CONSTANTS.ONE_MINUTE
        },
        GAME_EVENT: 'ONE_MINUTE_CORRECT_GUESS',
    },
    NINETY_POINTS: {
        TIME_INTERVAL: {
            MIN: ATTCACK_TIME_CONSTANTS.ONE_MINUTE,
            MAX: ATTCACK_TIME_CONSTANTS.TWO_MINUTES
        },
        GAME_EVENT: 'TWO_MINUTE_CORRECT_GUESS',
    },
    EIGHTY_POINTS: {
        TIME_INTERVAL: {
            MIN: ATTCACK_TIME_CONSTANTS.TWO_MINUTES,
            MAX: ATTCACK_TIME_CONSTANTS.THREE_MINUTES
        },
        GAME_EVENT: 'THREE_MINUTE_CORRECT_GUESS',
    },
    SEVENTY_POINTS: {
        TIME_INTERVAL: {
            MIN: ATTCACK_TIME_CONSTANTS.THREE_MINUTES,
            MAX: ATTCACK_TIME_CONSTANTS.FOUR_MINUTES
        },
        GAME_EVENT: 'FOUR_MINUTE_CORRECT_GUESS',
    },
    SIXTY_POINTS: {
        TIME_INTERVAL: {
            MIN: ATTCACK_TIME_CONSTANTS.FOUR_MINUTES,
            MAX: ATTCACK_TIME_CONSTANTS.FIVE_MINUTES
        },
        GAME_EVENT: 'FIVE_MINUTE_CORRECT_GUESS',
    },
    FIFTY_POINTS: {
        TIME_INTERVAL: {
            MIN: ATTCACK_TIME_CONSTANTS.FIVE_MINUTES,
            MAX: ATTCACK_TIME_CONSTANTS.EIGHT_MINUTES,
        },
        GAME_EVENT: 'FIVE_MINUTE_PLUS_CORRECT_GUESS',
    },
}

export const ATTACK_CONSTANTS = {
    /**
     * Used to decide if we can apply the attack to new aircraft or existing aircraft
     */
    NEW_AIRCRAFT: 'newAircraft',
    EXISTING_AIRCRAFT: 'existingAircraft',
}

export const ATTACKED_AIRCRAFT_ON_ARRIVAL = {
    AIRCRAFT_DISEPEARS: 'aircraftDisappears',
    AIRCRAFT_PROCEEDS_AS_NORMAL: 'aircraftProceedsAsNormal',
}

export const ATTACK_INFORMATION = {
    [GAME_ATTACK_TYPES.REGULAR]: {
        settingName: "",
        appliesToFlightCategory: [],
        appliesTo: [],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.FALSE_HEADING]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_FALSE_HEADING,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_DISEPEARS],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.FALSE_INFORMATION]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_FALSE_INFORMATION,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL, FLIGHT_CATEGORY.DEPARTURE],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT, ATTACK_CONSTANTS.EXISTING_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_PROCEEDS_AS_NORMAL],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.FALSE_SQUAWK]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_FALSE_SQUAWK,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL, FLIGHT_CATEGORY.DEPARTURE],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT, ATTACK_CONSTANTS.EXISTING_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_PROCEEDS_AS_NORMAL],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.NON_MOVING]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_NON_MOVING,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL, FLIGHT_CATEGORY.DEPARTURE],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT, ATTACK_CONSTANTS.EXISTING_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_PROCEEDS_AS_NORMAL],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.NON_RESPONSIVE]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_NON_RESPONSIVE,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT, ATTACK_CONSTANTS.EXISTING_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_DISEPEARS],
        scoringEnabled: true,
        respondsToCommand: false
    },
    [GAME_ATTACK_TYPES.POSITION_ALTERING]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_POSITION_ALTERING,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_DISEPEARS],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.IMPERSONATED_AIRCRAFT]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_IMPERSONATED_AIRCRAFT,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_PROCEEDS_AS_NORMAL],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.DUPLICATED_AIRCRAFT]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_DUPLICATED_AIRCRAFT,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_DISEPEARS],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.FLOODING_OF_NON_RESPONSIVE]: {
        settingName: ATTACK_SETTING_NAMES.FLOODING_OF_NON_RESPONSIVE,
        appliesToFlightCategory: [],
        appliesTo: [],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_DISEPEARS],
        scoringEnabled: false,
        respondsToCommand: false,
    },
    [GAME_ATTACK_TYPES.SYBIL]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_SYBIL,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_PROCEEDS_AS_NORMAL],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.GPS_JAMMING]: {
        settingName: "",
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL, FLIGHT_CATEGORY.DEPARTURE],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT, ATTACK_CONSTANTS.EXISTING_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_PROCEEDS_AS_NORMAL],
        scoringEnabled: true,
        respondsToCommand: true,
    },
    [GAME_ATTACK_TYPES.DRONE_ATTACK]: {
        settingName: ATTACK_SETTING_NAMES.PROBABILITY_OF_DRONE_ATTACK,
        appliesToFlightCategory: [FLIGHT_CATEGORY.ARRIVAL],
        appliesTo: [ATTACK_CONSTANTS.NEW_AIRCRAFT, ATTACK_CONSTANTS.EXISTING_AIRCRAFT],
        onArrival: [ATTACKED_AIRCRAFT_ON_ARRIVAL.AIRCRAFT_PROCEEDS_AS_NORMAL],
        scoringEnabled: false,
        respondsToCommand: true,
    },
}
